/**
 * Created by hp on 2017/6/12.
 */
import React, {Component} from 'react';
import {connect} from 'react-redux';
import { setEvent } from '../../services'
import {renderMoney} from '../../utils';


import '../../styles/lecture/LectureDiscountPanel.css';

class LectureDiscountPanel extends Component {
    render() {
        let {lectureMoney, discount, limitMoney} = this.props;
        lectureMoney = limitMoney ? limitMoney : lectureMoney;
        setEvent({name: 'wk_lecture-show-discount-panel'})
        return (
            <div className="lecture-discount-panel">
                <p className="weui-padding text-justify border-line">
                    课程学费<span className="fr">¥{renderMoney(lectureMoney)}</span>
                </p>
                <p className="weui-padding text-justify border-line" onClick={() => {
                    this.props.dispatch({
                        type: 'COUPON_SELECT_SHOW'
                    })
                }}>
                    选择优惠<span className="fr key-num discount__kurisu">已使用优惠码抵扣¥{renderMoney(discount.price)}</span>
                </p>
                <p className="weui-padding text-justify border-line">
                    还需支付
                    {lectureMoney > discount.price ?
                        <span className="fr key-num">¥{renderMoney(lectureMoney - discount.price)}</span>
                        :
                        <span className="fr key-num">¥0</span>
                    }
                </p>
            </div>
        )
    }
}

export default connect((state) => ({
    lectureMoney: state.lecture.lecture.money,
    discount: state.lecture.discount,
    limitMoney: state.lecture.lecture.limit_money ? state.lecture.lecture.limit_money.money : null,
}))(LectureDiscountPanel);


// WEBPACK FOOTER //
// ./src/components/lecture/LectureDiscountPanel.js